export default __webpack_public_path__ + "static/media/reduce.eb16838e.png";